import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Box, Typography, Container, IconButton, Button} from '@mui/material';
// import HomeIcon from '@mui/icons-material/Home';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useConfig, configKeys, MONTHLY_PAYMENT } from './ConfigHolder';
import { useAuth } from './AuthProvider';
import { isEmpty } from 'lodash';
import { DialogContent, DialogTitle } from '@mui/material';
import { Drawer } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Profile from './Profile';
import { findByLabel } from './ConfigHolder';
import PayPalDialog from "./PayPalDialog";


const Header = ( { dualView, index, toggleMode }) => {
  const { config } = useConfig();
  const { isAuthenticated} = useAuth();
  const [langname, setLangname] = useState('');
  const [showProfile, setShowProfile] = useState(false);
  const [showPayPalDialog, setShowPayPalDialog] = useState(false);

const startPayment = () => {
    // 1) close the Drawer (removes aria-hidden conflict)
    setShowProfile(false);
    // 2) after a tick, open the PayPal dialog (which is outside the Drawer)
    setTimeout(() => setShowPayPalDialog(true), 200);
  };


  useEffect(() => {
    if (!isEmpty(config)) {
      // setLangname(config[configKeys.langLearn]?.label);
      const lname = findByLabel(config[configKeys.langLearn]?.label);
      if (lname) {
        setLangname(lname.native);
      }}
  }, [config]);

  const handleProfileClick = () => {
    setShowProfile(true);
  };

  const handleProfileClose = () => {
    setShowProfile(false);
  }
  return (
    <Box sx={{ flexGrow: 1, width: '100%', position: 'sticky', top: 0, zIndex: 1100, mb: 0.5,  }}>
    <AppBar
      position="static"
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        // maxWidth: 'md',
        height: 56, // Height is critical here
        mt:1,
      }}
    >
      <Container sx={{ paddingY: 0}}>
        <Toolbar >
        <Box
          component="img"
          src="/favicon.ico"
          alt="App Icon"
          sx={{ width: 32, height: 32, mr: 2, ml:0 }}
        />
         
          { ((dualView !== undefined) && !dualView)  ? (
            <Box>
              <Button
                variant="text"
                onClick={toggleMode}
                sx={{ fontSize: '14px', ml: 2, textDecoration: 'underline', color: 'white' }}
              >
                {index === 0 ? `Practice ${langname} >` : `< ${langname} CONTENT`}
              </Button>
            </Box>

          ) : (
             <Typography sx={{ ml: 2, fontSize: '16px', paddingY: 0 }}>
            {/* Learn {langname} */}
            {langname}
          </Typography>
          ) }
          <Box sx={{ flexGrow: 1, paddingY: 0 }} /> {/* Spacer to push items to the right */}
          {isAuthenticated() && (
           <IconButton
             color="inherit"
             sx={{ borderRadius: '50%', p: 0.5, ml: 1 }}
             onClick = {handleProfileClick}
           >
             <AccountCircleIcon />
           </IconButton>
       )}
        </Toolbar>
      </Container>
    </AppBar>
    <Drawer anchor = "right" open={showProfile} onClose={handleProfileClose}>
      <DialogTitle sx = {{fontWeight: 'bold'}}>
        Profile
        <IconButton
          aria-label="close"
          onClick={handleProfileClose}
          style={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Profile onClose={handleProfileClose} onStartPayment={startPayment} />
      </DialogContent>
    </Drawer>
    
    <PayPalDialog open={showPayPalDialog} onClose={() => setShowPayPalDialog(false)} amount={MONTHLY_PAYMENT} />

  </Box>
  );
};

export default Header;
